<template>
  <div class='appointBox' style='width: calc(95% - 200px);'>
    <div class='eq_header'>
      <div style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
        使用记录列表</div>
      <span style='font-size:14px;color:#999999'>您的位置：个人中心><span style="color:#188335">使用记录</span></span>
    </div>
    <div style='width: 100%;'>
      <div class='sdau_search'>
        <el-form ref="form" :model="formData" label-width="100px" :inline="true">
          <el-row>
            <el-col :span='8'>
              <el-form-item label="上机日期">
                <el-date-picker @change="handleTimeuse" v-model="dateRangeuse" size="small" value-format="yyyy-MM-dd"
                  type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="截止日期"
                  clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约申请日期">
                <el-date-picker @change="handleTime" v-model="dateRange" size="small" value-format="yyyy-MM-dd"
                  type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="截止日期"
                  clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约单号">
                <el-input placeholder="请输入设预约单号" v-model="formData.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="使用人姓名">
                <el-input placeholder="请输入使用人姓名" v-model="formData.usageUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="使用人学号">
                <el-input placeholder="请输入使用人学号" v-model="formData.usageUserStudentNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" :index='Nindex' width="55" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="code" width="100" label="预约单号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentNumber" width="100" label="设备编号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentName" width="100" label="设备名称" align="center">
        </el-table-column>
        <el-table-column prop="nodeName" width="100" label="设备分类" align="center">
        </el-table-column>
        <el-table-column prop="usageUserName" width="100" label="使用人姓名" align="center">
        </el-table-column>
        <el-table-column prop="usageUserStudentNo" width="120" label="使用人学号" align="center">
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="usageDate" width="140" label="上机日期" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="usageStartTime" width="140" label="上机时间" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="usageEndTime" width="140" label="下机时间" align="center">
        </el-table-column>
        <el-table-column prop="usageDuration" width="100" label="计费时长" align="center">
          <template slot-scope="scope">
            <span v-if='scope.row.usageDuration'>{{ scope.row.usageDuration + '分钟' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="usageCount" width="100" label="计费件数" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createReservationDate" width="140" label="预约申请日期" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationStartTime" width="140" label="预约开始时间" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationEndTime" width="140" label="预约结束时间" align="center">
        </el-table-column>
        <el-table-column prop="reservationDuration" width="100" label="预约时长" align="center">
          <template slot-scope="scope">
            <span v-if='scope.row.reservationDuration'>{{ scope.row.reservationDuration + '分钟' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reservationCount" width="100" label="预约件数" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button v-if='!scope.row.uploadFileList || !scope.row.uploadFileList.length' type="text" size="small"
              @click="showdelappoints(scope.row, 0)">填写下机信息</el-button>
            <el-button v-else type="text" size="small" @click="showdelappoints(scope.row, 1)">查看下机信息</el-button>
            <!-- <span v-if='[0,5,"0","5"].includes(scope.row.status)'>暂无操作</span> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
        :limit.sync="formData.pageSize" @pagination='init' />
    </div>
    <usementDialog v-if="showDelappoint" :showDelappoint='showDelappoint' @cancel="cancel" :rowData='rowData'
      :dialogTitle="dialogTitle" />
  </div>
</template>
<script>
import usementDialog from './dialog/usementDialog.vue'
export default {
  props: {},
  components: {
    usementDialog
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
      },
      total: 1,
      pageSizes: [5, 10, 20, 50, 100, 300],
      tableData: [],
      dateRange: [],
      dateRangeuse: [],
      showDelappoint: false,
      rowData: {}
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.dateRange = []
      this.init()
    },
    handleTime(date) {
      if (date) {
        this.formData.createTimeStart = date[0]
        this.formData.createTimeEnd = date[1]
      } else {
        this.formData.createTimeStart = []
        this.formData.createTimeEnd = []
      }
    },
    handleTimeuse(date) {
      if (date) {
        this.formData.usageTimeStart = date[0]
        this.formData.usageTimeEnd = date[1]
      } else {
        this.formData.usageTimeStart = []
        this.formData.usageTimeEnd = []
      }
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    cancel() {
      this.showDelappoint = false
      this.init()
    },
    init() {
      this.$net(`/sdau/usageRecord`, 'get', this.formData).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    showdelappoints(row, type) {
      this.showDelappoint = true
      this.dialogTitle = type == 1 ? '查看下机信息' : '填写下机信息'
      this.rowData = row
    },
    appointagain(row) {
      this.$router.push({
        path: '/appointment',
        query: {
          id: row.equipmentId
        }
      })
    },
    showMessage(row, status) {
      this.dialogTitle = status == 0 ? '审批意见' : '取消原因'
      this.cantreason = status == 0 ? row.auditRemark : row.cancelReason
      this.dialogStatus = status
      this.showDelappoint = true
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}

.eq_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>